/* eslint-disable import/no-unresolved */
import { Link } from 'gatsby';
import React from 'react';
import GoodFirms1 from 'assets/resources/goodfirms.inline.svg';
import GoodFirms2 from 'assets/resources/goodfirms2.inline.svg';
import BadgeTechreviewerBlockchain from 'assets/resources/badgeTechreviewerBlockchain.svg';
import algorandLogoWhite from 'assets/resources/algorand_full_logo_white.png';

import { AiFillFacebook, AiFillLinkedin } from 'react-icons/ai';
import { FaTwitter, FaInstagram } from 'react-icons/fa';

// eslint-disable-next-line import/no-unresolved
import logoWhite from 'assets/resources/logo_white.svg';
import OnlyForSEO from './OnlyForSEO';
import ImgHTML from './ImgHTML';
import ClutchWidget from './ClutchWidget';
import LazyLoad from './LazyLoad';

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col d-flex flex-column flex-lg-row justify-content-between">
            <div className="">
              <div className="title mb-0">See our company on:</div>
              <LazyLoad className="d-flex flex-wrap logos">
                <div
                  className="logo widget d-flex align-items-center"
                  style={{ width: '12rem' }}
                >
                  <ClutchWidget />
                </div>
                <div className="my-3 firms-section">
                  <a
                    href="https://www.goodfirms.co/companies/view/22303/ulam-labs"
                    className="logo firms"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <GoodFirms1 className="svg-icon" />
                  </a>
                  <a
                    href="https://www.goodfirms.co/companies/view/22303/ulam-labs"
                    className="logo firms"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <GoodFirms2 className="svg-icon" />
                  </a>
                </div>

                <div className="icon mt-2">
                  <a
                    href="https://techreviewer.co/top-blockchain-development-companies
                  "
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <ImgHTML
                      src={BadgeTechreviewerBlockchain}
                      alt="badge icon"
                      title="badge icon"
                      style={{ width: '55px' }}
                    />
                  </a>
                </div>
              </LazyLoad>
            </div>
            <div className="partner">
              <div className="title highlight position-relative mb-4">
                We are official Partner of:
              </div>
              <div className="icon">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.algorand.com"
                >
                  <ImgHTML
                    src={algorandLogoWhite}
                    alt="badge icon"
                    title="badge icon"
                    style={{ width: '12rem' }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="hor-line" />
        <div className="row d-flex flex-column">
          <div className="col">
            <div className="d-flex flex-column flex-lg-row">
              <div className="d-flex p-0 col-lg-8 flex-wrap justify-content-md-between">
                <div className="col-6 col-md-3 p-0">
                  <div className="section-footer menu positions-list p-0">
                    <ul className="list-unstyled footer-list">
                      <li className="highlight">Menu</li>
                      <li>
                        <Link to="/software-services/">Services</Link>
                      </li>
                      <li>
                        <Link to="/case-studies/">Case studies</Link>
                      </li>
                      <li>
                        <Link to="/blog/">Blog</Link>
                      </li>
                      <li>
                        <Link to="/software-services/#technologies/">
                          Technologies
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/#industries/">
                          Industries
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-6 col-md-4 p-0">
                  <div className="section-footer menu positions-list p-0">
                    <ul className="list-unstyled footer-list">
                      <li className="highlight">Software services</li>
                      <li>
                        <Link to="/software-services/python-development/">
                          Python development
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/javascript-development/">
                          JavaScript development
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/blockchain-development/">
                          Blockchain development
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/mvp-minimum-viable-product-development/">
                          MVP - minimum viable product development
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/cryptocurrency-trading-platforms/">
                          Cryptocurrency & trading platforms
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/building-products/">
                          Building products
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/code-audit/">
                          Code audit
                        </Link>
                      </li>
                      <li>
                        <Link to="/software-services/team-extension/">
                          Team extension
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col col-md-3 p-0">
                  <div className="section-footer menu positions-list pt-0 pl-0">
                    <ul className="list-unstyled footer-list">
                      <li className="highlight">Company:</li>
                      <li>
                        <Link to="/about-us/">About us</Link>
                      </li>
                      <li>
                        <Link to="/careers/">Careers</Link>
                      </li>
                      <li>
                        <Link to="/how-we-work/">How we work</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 d-lg-flex justify-content-lg-end p-0 mb-4">
                <div className="section-footer information p-0">
                  <Link to="/">
                    <ImgHTML
                      src={logoWhite}
                      className="logo"
                      alt="Ulam Labs logo white"
                      title="Ulam Labs white logo"
                      fetchImmediately
                    />
                  </Link>
                  <div className="contact">
                    <a href="mailto:contact@ulam.io">contact@ulam.io</a>
                    Grabiszyńska 163/508
                    <br />
                    53-439 Wrocław, Poland
                  </div>
                  <div className="social">
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://twitter.com/ulamlabs"
                    >
                      <FaTwitter />
                      <OnlyForSEO text="twitter link" />
                    </a>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.facebook.com/ulamlabs/"
                    >
                      <AiFillFacebook />
                      <OnlyForSEO text="facebook link" />
                    </a>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.linkedin.com/company/ulam-labs/"
                    >
                      <AiFillLinkedin />
                      <OnlyForSEO text="linkedin link" />
                    </a>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.instagram.com/ulamlabs/"
                    >
                      <FaInstagram />
                      <OnlyForSEO text="instagram link" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hor-line mt-0" />
        <div className="row d-flex justify-content-between">
          <div className="col">
            <div className="copy">
              Copyright &copy;{new Date().getFullYear()} Ulam Labs
            </div>
          </div>
          <div className="col copy-links">
            <div className="ml-auto d-flex flex-column align-items-end justify-content-end flex-sm-row wrapper">
              <Link to="/terms-of-service/">Terms of Service</Link>
              <Link to="/privacy-policy/">Privacy policy</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
